export const ChangeDate = {
  any: 0,
  hours1: 1,
  hours3: 2,
  today: 3,
  days3: 4,
  week: 5,
} as const;
